import type { PayloadAction } from "@reduxjs/toolkit";
import { createSlice } from "@reduxjs/toolkit";
import { GetMeRes } from "../../interfaces/user.interface";
import { GetPermissionRes } from "../../interfaces/role.interface";

export interface UserState {
  id: number
  first_name: string
  last_name: string
  email: string
  email_verified: boolean
  username: string
  totp_enable: boolean
  roles: number[]
  roleName: string
  permissions: GetPermissionRes[]
}

const initialState: UserState = {
  id: 0,
  first_name: "",
  last_name: "",
  email: "",
  email_verified: false,
  username: "",
  totp_enable: true,
  roles: [],
  roleName: "",
  permissions: []
};

export const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    setUser: (state, actions) => {
      const temp = actions.payload as GetMeRes
      state.id = temp.id
      state.first_name = temp.first_name
      state.last_name = temp.last_name
      state.email = temp.email
      state.email_verified = temp.email_verified
      state.username = temp.username
      state.totp_enable = temp.totp_enable
      state.roles = temp.roles
    },
    setRoleName: (state, actions) =>{
      state.roleName = actions.payload
    },

    setPermissions: (state, actions) =>{
      state.permissions = actions.payload
    }
  },
});


